import {cn} from '@/lib/utils'
import React from 'react'
import {WuAppHeaderAccount} from './components/account/WuAppHeaderAccount'
import {WuAppHeaderBar} from './components/breadcrumb/WuAppHeaderBar'
import {WuAppHeaderHelp} from './components/help/WuAppHeaderHelp'
import {WuAppHeaderMenu} from './components/productSwitcher/WuAppHeaderMenu'
import {IWuAppHeaderAccount} from './types/WuAppHeaderAccount'
import {IWuAppHeaderBreadcrumbItem} from './types/WuAppHeaderBreadcrumbItem'
import {IWuAppHeaderMenuItem} from './types/WuAppHeaderMenuItem'
import './WuAppHeader.css'

export interface IWuAppHeaderProps
  extends React.HTMLAttributes<HTMLBaseElement> {
  productName: string
  categories: IWuAppHeaderMenuItem[]
  user?: IWuAppHeaderAccount
  /**
   * @deprecated this will not be used in future please use children instead
   */
  breadcrumbs?: IWuAppHeaderBreadcrumbItem[]
  children?: React.ReactNode
  onLogout?: () => void
  homeLink?: string
  dir?: 'ltr' | 'rtl'
  brandColor?: {
    base: string
    hover: string
  }
  expandAll?: boolean
  DataCenter?: React.ReactElement
}

export const WuAppHeader: React.FC<IWuAppHeaderProps> = props => {
  const {
    productName,
    categories = [],
    user,
    breadcrumbs,
    children,
    onLogout,
    homeLink = window.location.origin,
    brandColor,
    dir = 'ltr',
    expandAll,
    DataCenter,
  } = props
  return (
    <div className="sticky top-0 z-50 w-full">
      <header
        className={cn(
          'h-12 flex items-center justify-between relative bg-blue-switcher text-white',
          dir === 'rtl' && 'flex-row-reverse',
          props.className,
        )}
        style={props.style}
      >
        <section className="flex items-center gap-2 shrink-0">
          <WuAppHeaderMenu
            productCategories={categories}
            activeProductName={productName}
            activeProductColor={brandColor}
            dir={dir}
            homeLink={homeLink}
            expandAll={expandAll}
          />
        </section>

        <WuAppHeaderBar breadcrumbs={breadcrumbs} dir={dir}>
          {children}
        </WuAppHeaderBar>

        <section
          className={cn(
            'flex items-center justify-end shrink-0 gap-2',
            dir === 'rtl' ? 'flex-row-reverse pl-4' : 'flex-row pr-4',
          )}
        >
          <WuAppHeaderHelp dir={dir} />
          <WuAppHeaderAccount
            user={user}
            onLogout={onLogout}
            dir={dir}
            DataCenter={DataCenter}
          />
        </section>
      </header>
    </div>
  )
}
